// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1ZW4f","loaderOuter":"PageOverlayLoader_loaderOuter__3MD5x"};